import React, { useState } from "react";
import AboutOne from "../../assets/image_fx_ (44).jpg";
import AboutTwo from "../../assets/about-2.jpg";
import AboutThree from "../../assets/About-3.jpg";
import { careers } from "./data";
import "./workWithUs.css";
import { useMediaQuery } from "react-responsive";
import FirstComponent from "../../components/careersComponents/FirstComponent";
import emailjs from "emailjs-com";
import axios from "axios";
import Swal from "sweetalert2";

const WorkWithUs = () => {
  const [expandedJobId, setExpandedJobId] = useState(null);
  const [selectedPositionId, setSelectedPositionId] = useState(null);

  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });

  const handleJobClick = (jobId) => {
    setExpandedJobId((prev) => (prev === jobId ? null : jobId));
    setSelectedPositionId(null);
  };

  const handleApplyClick = (positionId) => {
    setSelectedPositionId(positionId);
  };

  const handleCloseJob = () => {
    setExpandedJobId(null);
    setSelectedPositionId(null);
  };

  const selectedPosition = careers
    .flatMap((career) => career.positions)
    .find((position) => position.id === selectedPositionId);

  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedPositionMob, setSelectedPositionMob] = useState("");
  const [jobDetails, setJobDetails] = useState(null);

  // Handle category change
  const handleCategoryChange = (e) => {
    const category = e.target.value;
    setSelectedCategory(category);
    setSelectedPositionMob("");
    setJobDetails(null);
  };

  // Handle position change
  const handlePositionChange = (e) => {
    const positionTitle = e.target.value;

    // Find the job details based on the selected category and position
    const selectedCareer = careers.find(
      (career) => career.category === selectedCategory
    );
    const selectedJob = selectedCareer.positions.find(
      (position) => position.title === positionTitle
    );

    setSelectedPositionMob(positionTitle);
    setJobDetails(selectedJob);
  };

  const handleReset = () => {
    setSelectedCategory("");
    setSelectedPositionMob("");
    setJobDetails(null);
  };

  // =============== Handle Submit From ==============

  const [uploadMessage, setUploadMessage] = useState("");
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    linkedin: "",
    workSamples: "",
    additionalInfo: "",
    file: null,
  });

  const [isSending, setIsSending] = useState(false);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (files) {
      setFormData((prev) => ({ ...prev, file: files[0] }));
      setUploadMessage(`${files[0].name} uploaded successfully!`);
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSending(true);
    setUploadMessage("");
    try {
      let fileDownloadLink = "";
      let fileName = "";

      if (formData.file) {
        setUploadMessage("Uploading file...");

        // Upload file to File.io
        const formDataForUpload = new FormData();
        formDataForUpload.append("file", formData.file);

        const uploadResponse = await axios.post(
          "https://file.io",
          formDataForUpload
        );

        fileDownloadLink = uploadResponse.data.link;
        fileName = formData.file.name;

        setUploadMessage("File uploaded successfully!");
      } else {
        setUploadMessage("No file selected for upload.");
      }

      // Prepare data for EmailJS
      const emailData = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        phone: formData.phone,
        linkedin: formData.linkedin,
        workSamples: formData.workSamples,
        additionalInfo: formData.additionalInfo,
        downloadLink: fileDownloadLink,
        fileName: fileName,
      };

      // Send the data using EmailJS
      await emailjs.send(
        "service_hmii839",
        "template_pmorzvq",
        emailData,
        "iZ4Nyz4BPL0K1UJgp"
      );
      Swal.fire({
        icon: "success",
        title: "Message Sent!",
        text: "Your application has been successfully submitted.",
      });
      // Reset the form
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        linkedin: "",
        workSamples: "",
        additionalInfo: "",
        file: null,
      });
    } catch (error) {
      console.error("Error during submission:", error);
      setUploadMessage("File upload failed. Please try again.");
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text: "An error occurred while submitting your application. Please try again later.",
      });
    } finally {
      setIsSending(false);
    }
  };

  return (
    <section className="work page">
      {isMobile ? (
        <>
          <div className="work-container">
            <div className="title">
              <h1>
                Company Culture at <span className="title-word">CS Lab</span>
              </h1>
            </div>
            <div className="box box-1">
              <div className="box-right">
                <div className="text-box">
                  <h1>1. Creativity and Innovation</h1>
                  <div className="image-box">
                    <img src={AboutOne} alt="BrainStorm" />
                  </div>
                  <p>
                    At CS Lab, we believe creativity is the cornerstone of
                    impactful marketing solutions. Our team is constantly
                    encouraged to think outside the box, explore bold ideas, and
                    embrace unconventional approaches to problem-solving. This
                    commitment to creativity ensures that we always deliver
                    innovative solutions tailored to our clients' needs.
                  </p>
                  <p>
                    By fostering a culture of innovation, we create a dynamic
                    and engaging workplace. Every project becomes an opportunity
                    to experiment, learn, and push the boundaries of what’s
                    possible, making each achievement even more rewarding.
                  </p>
                </div>
              </div>
            </div>
            <div className="box box-2">
              <div className="box-right">
                <div className="text-box">
                  <h1>2. Collaboration and Integrity</h1>
                  <div className="image-box">
                    <img src={AboutTwo} alt="BrainStorm" />
                  </div>
                  <p>
                    Collaboration lies at the heart of our success at CS Lab. We
                    maintain a transparent and inclusive environment where team
                    members work together closely, sharing insights, skills, and
                    feedback to achieve common goals. This spirit of teamwork
                    ensures that no challenge is faced alone and that every
                    voice is heard.
                  </p>
                  <p>
                    Integrity is equally vital to our culture, guiding every
                    decision and interaction. We foster trust by promoting open
                    communication, respecting diverse perspectives, and
                    empowering individuals to contribute meaningfully. Together,
                    these values create a supportive and inspiring workplace.
                  </p>
                </div>
              </div>
            </div>
            <div className="box box-3">
              <div className="box-right">
                <div className="text-box">
                  <h1>3. Growth and Results</h1>
                  <div className="image-box">
                    <img src={AboutThree} alt="BrainStorm" />
                  </div>
                  <p>
                    Growth is a shared journey at CS Lab. We invest in our team
                    by providing continuous learning opportunities, access to
                    the latest tools, and exposure to industry trends. This
                    commitment ensures that our employees are always equipped to
                    excel in a fast-evolving digital landscape.
                  </p>
                  <p>
                    Our focus on measurable results keeps us driven and
                    motivated. Every project is approached with a
                    results-oriented mindset, enabling our team to achieve
                    meaningful outcomes that fuel both client success and
                    personal fulfillment.
                  </p>
                </div>
              </div>
            </div>
            <div className="job-listing">
              <div className="job-listing-left">
                <div className="title">
                  <h2>
                    <span className="title-word">Job</span> Listing (
                    {careers.length})
                  </h2>
                  <p>Filters</p>
                </div>
                <div className="dropdowns">
                  {/* Dropdown for Categories */}
                  <select
                    value={selectedCategory}
                    onChange={handleCategoryChange}
                  >
                    <option value="" disabled>
                      Select a Category
                    </option>
                    {careers.map((career) => (
                      <option key={career.id} value={career.category}>
                        {career.category}
                      </option>
                    ))}
                  </select>
                  {/* Dropdown for Positions */}
                  <select
                    value={selectedPositionMob}
                    onChange={handlePositionChange}
                    disabled={!selectedCategory}
                  >
                    <option value="" disabled>
                      Select a Position
                    </option>
                    {selectedCategory &&
                      careers
                        .find((career) => career.category === selectedCategory)
                        .positions.map((position) => (
                          <option key={position.id} value={position.title}>
                            {position.title}
                          </option>
                        ))}
                  </select>
                </div>
                {/* Display Job Details or Default Message */}
                <div className="job-listing-right">
                  {selectedPositionMob && jobDetails ? (
                    <div className="second-component">
                      <div className="details-header">
                        <h3>{jobDetails.title}</h3>
                        <button className="close-button" onClick={handleReset}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                          >
                            <path
                              d="M16 18.5551L7.05703 27.4981C6.72243 27.8327 6.29658 28 5.77947 28C5.26236 28 4.8365 27.8327 4.5019 27.4981C4.1673 27.1635 4 26.7376 4 26.2205C4 25.7034 4.1673 25.2776 4.5019 24.943L13.4449 16L4.5019 7.05703C4.1673 6.72243 4 6.29658 4 5.77947C4 5.26236 4.1673 4.8365 4.5019 4.5019C4.8365 4.1673 5.26236 4 5.77947 4C6.29658 4 6.72243 4.1673 7.05703 4.5019L16 13.4449L24.943 4.5019C25.2776 4.1673 25.7034 4 26.2205 4C26.7376 4 27.1635 4.1673 27.4981 4.5019C27.8327 4.8365 28 5.26236 28 5.77947C28 6.29658 27.8327 6.72243 27.4981 7.05703L18.5551 16L27.4981 24.943C27.8327 25.2776 28 25.7034 28 26.2205C28 26.7376 27.8327 27.1635 27.4981 27.4981C27.1635 27.8327 26.7376 28 26.2205 28C25.7034 28 25.2776 27.8327 24.943 27.4981L16 18.5551Z"
                              fill="black"
                              fillOpacity="0.6"
                            />
                          </svg>
                        </button>
                      </div>
                      <div className="overview">
                        <h4>Role Overview:</h4>
                        <p>{jobDetails.description}</p>
                      </div>
                      <h4>Key Responsibilities:</h4>
                      <ul>
                        {jobDetails.responsibilities.map((item, index) => (
                          <li key={index}>
                            <div className="svg-box">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="10"
                                height="10"
                                viewBox="0 0 10 10"
                                fill="none"
                              >
                                <circle cx="5" cy="5" r="5" fill="#555" />
                              </svg>
                              <p>{item}</p>
                            </div>
                          </li>
                        ))}
                      </ul>
                      <h4>Requirements:</h4>
                      <ul>
                        {jobDetails.requirements.map((item, index) => (
                          <li key={index}>
                            <div className="svg-box">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="10"
                                height="10"
                                viewBox="0 0 10 10"
                                fill="none"
                              >
                                <circle cx="5" cy="5" r="5" fill="#555" />
                              </svg>
                              <p>{item}</p>
                            </div>
                          </li>
                        ))}
                      </ul>
                      {jobDetails.preferredSkills && (
                        <>
                          <h4>Preferred Skills:</h4>
                          <ul>
                            {jobDetails.preferredSkills.map((item, index) => (
                              <li key={index}>
                                <div className="svg-box">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="10"
                                    height="10"
                                    viewBox="0 0 10 10"
                                    fill="none"
                                  >
                                    <circle cx="5" cy="5" r="5" fill="#555" />
                                  </svg>
                                  <p>{item}</p>
                                </div>
                              </li>
                            ))}
                          </ul>
                        </>
                      )}
                      {jobDetails.whyJoinUs && (
                        <>
                          <h4>Why Join Us?</h4>
                          <ul>
                            {jobDetails.whyJoinUs.map((item, index) => (
                              <li key={index}>
                                <div className="svg-box">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="10"
                                    height="10"
                                    viewBox="0 0 10 10"
                                    fill="none"
                                  >
                                    <circle cx="5" cy="5" r="5" fill="#555" />
                                  </svg>
                                  <p>{item}</p>
                                </div>
                              </li>
                            ))}
                          </ul>
                        </>
                      )}
                      <div className="form-container">
                        <div className="form-intro">
                          <h4>Candidate Profile</h4>
                          <p>Please be sure to fill out all required fields.</p>
                          <p>* indicates a required field.</p>
                        </div>
                        <div className="form-right">
                          <form onSubmit={handleSubmit}>
                            <div className="input-box">
                              <input
                                type="text"
                                name="firstName"
                                placeholder="* First Name"
                                value={formData.firstName}
                                onChange={handleChange}
                              />
                            </div>
                            <div className="input-box">
                              <input
                                type="text"
                                name="lastName"
                                placeholder="* Last Name"
                                value={formData.lastName}
                                onChange={handleChange}
                              />
                            </div>
                            <div className="input-box">
                              <input
                                type="email"
                                name="email"
                                placeholder="* Email Address"
                                value={formData.email}
                                onChange={handleChange}
                              />
                            </div>
                            <div className="input-box">
                              <input
                                type="text"
                                name="phone"
                                placeholder="* Phone Number"
                                value={formData.phone}
                                onChange={handleChange}
                              />
                            </div>
                            <div className="file-upload-box">
                              <p>* Work Experience</p>
                              <div className="input-box upload-area">
                                <label
                                  htmlFor="fileInput"
                                  className="upload-label mb-0"
                                >
                                  <div className="upload-content">
                                    <div className="icon-box">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="41"
                                        height="40"
                                        viewBox="0 0 41 40"
                                        fill="none"
                                      >
                                        <g clipPath="url(#clip0_712_261)">
                                          <path
                                            d="M32.75 16.7337C31.6167 10.9837 26.5667 6.66699 20.5 6.66699C15.6833 6.66699 11.5 9.40033 9.41667 13.4003C4.4 13.9337 0.5 18.1837 0.5 23.3337C0.5 28.8503 4.98333 33.3337 10.5 33.3337H32.1667C36.7667 33.3337 40.5 29.6003 40.5 25.0003C40.5 20.6003 37.0833 17.0337 32.75 16.7337ZM23.8333 21.667V28.3337H17.1667V21.667H12.1667L20.5 13.3337L28.8333 21.667H23.8333Z"
                                            fill="black"
                                            fillOpacity="0.6"
                                          />
                                        </g>
                                        <defs>
                                          <clipPath id="clip0_712_261">
                                            <rect
                                              width="40"
                                              height="40"
                                              fill="white"
                                              transform="translate(0.5)"
                                            />
                                          </clipPath>
                                        </defs>
                                      </svg>
                                    </div>
                                    <div className="text">
                                      <p className="mb-2">
                                        Drag & Drop your files here
                                      </p>
                                      <p className="mb-0">
                                        (PDF, DOCX, TXT or HTML)
                                      </p>
                                    </div>
                                  </div>
                                </label>
                                <input
                                  type="file"
                                  id="fileInput"
                                  accept=".pdf,.docx,.txt,.html"
                                  onChange={handleChange}
                                  style={{ display: "none" }}
                                />
                              </div>
                              {uploadMessage && (
                                <p className="upload-message">
                                  {uploadMessage}
                                </p>
                              )}
                            </div>
                            <div className="input-box">
                              <label>LinkedIn Profile</label>
                              <input
                                type="text"
                                name="linkedin"
                                placeholder="Profile URL"
                                value={formData.linkedin}
                                onChange={handleChange}
                              />
                            </div>
                            <div className="input-box">
                              <label>Work Samples</label>
                              <input
                                type="text"
                                name="workSamples"
                                placeholder="Personal Website, Portfolio, GitHub etc."
                                value={formData.workSamples}
                                onChange={handleChange}
                              />
                            </div>
                            <div className="input-box textarea">
                              <textarea
                                name="additionalInfo"
                                placeholder="Additional Information..."
                                value={formData.additionalInfo}
                                onChange={handleChange}
                              />
                            </div>
                            <button
                              className="btn"
                              type="submit"
                              disabled={isSending}
                              style={{
                                opacity:
                                  formData.file || formData.firstName ? 1 : 0.5,
                                pointerEvents:
                                  formData.file || formData.firstName
                                    ? "auto"
                                    : "none",
                              }}
                            >
                              {isSending ? "Sending..." : "Send Message"}
                            </button>
                            {uploadMessage && (
                              <p className="upload-message">{uploadMessage}</p>
                            )}
                          </form>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <FirstComponent />
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      ) : isTablet ? (
        <div className="work-container">
          <div className="title">
            <h1>
              Company Culture at <span className="title-word">CS Lab</span>
            </h1>
          </div>
          <div className="box box-1">
            <div className="box-left">
              <div className="image-box">
                <img src={AboutOne} alt="BrainStorm" />
              </div>
            </div>
            <div className="box-right">
              <div className="text-box">
                <h1>1. Creativity and Innovation</h1>
                <p>
                  At CS Lab, we believe creativity is the cornerstone of
                  impactful marketing solutions. Our team is constantly
                  encouraged to think outside the box, explore bold ideas, and
                  embrace unconventional approaches to problem-solving. This
                  commitment to creativity ensures that we always deliver
                  innovative solutions tailored to our clients' needs.
                </p>
                <p>
                  By fostering a culture of innovation, we create a dynamic and
                  engaging workplace. Every project becomes an opportunity to
                  experiment, learn, and push the boundaries of what’s possible,
                  making each achievement even more rewarding.
                </p>
              </div>
            </div>
          </div>
          <div className="box box-2">
            <div className="box-right">
              <div className="text-box">
                <h1>2. Collaboration and Integrity</h1>
                <p>
                  Collaboration lies at the heart of our success at CS Lab. We
                  maintain a transparent and inclusive environment where team
                  members work together closely, sharing insights, skills, and
                  feedback to achieve common goals. This spirit of teamwork
                  ensures that no challenge is faced alone and that every voice
                  is heard.
                </p>
                <p>
                  Integrity is equally vital to our culture, guiding every
                  decision and interaction. We foster trust by promoting open
                  communication, respecting diverse perspectives, and empowering
                  individuals to contribute meaningfully. Together, these values
                  create a supportive and inspiring workplace.
                </p>
              </div>
            </div>
            <div className="box-left">
              <div className="image-box">
                <img src={AboutTwo} alt="BrainStorm" />
              </div>
            </div>
          </div>
          <div className="box box-3">
            <div className="box-left">
              <div className="image-box">
                <img src={AboutThree} alt="BrainStorm" />
              </div>
            </div>
            <div className="box-right">
              <div className="text-box">
                <h1>3. Growth and Results</h1>
                <p>
                  Growth is a shared journey at CS Lab. We invest in our team by
                  providing continuous learning opportunities, access to the
                  latest tools, and exposure to industry trends. This commitment
                  ensures that our employees are always equipped to excel in a
                  fast-evolving digital landscape.
                </p>
                <p>
                  Our focus on measurable results keeps us driven and motivated.
                  Every project is approached with a results-oriented mindset,
                  enabling our team to achieve meaningful outcomes that fuel
                  both client success and personal fulfillment.
                </p>
              </div>
            </div>
          </div>
          <div className="job-listing">
            <div className="job-listing-left">
              <div className="title">
                <h2>
                  <span className="title-word">Job</span> Listing (
                  {careers.length})
                </h2>
                <p>Filters</p>
              </div>
              <div className="dropdowns">
                {/* Dropdown for Categories */}
                <select
                  value={selectedCategory}
                  onChange={handleCategoryChange}
                >
                  <option value="" disabled>
                    Select a Category
                  </option>
                  {careers.map((career) => (
                    <option key={career.id} value={career.category}>
                      {career.category}
                    </option>
                  ))}
                </select>
                {/* Dropdown for Positions */}
                <select
                  value={selectedPositionMob}
                  onChange={handlePositionChange}
                  disabled={!selectedCategory}
                >
                  <option value="" disabled>
                    Select a Position
                  </option>
                  {selectedCategory &&
                    careers
                      .find((career) => career.category === selectedCategory)
                      .positions.map((position) => (
                        <option key={position.id} value={position.title}>
                          {position.title}
                        </option>
                      ))}
                </select>
              </div>
              {/* Display Job Details or Default Message */}
              <div className="job-listing-right">
                {selectedPositionMob && jobDetails ? (
                  <div className="second-component">
                    <div className="details-header">
                      <h3>{jobDetails.title}</h3>
                      <button className="close-button" onClick={handleReset}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                        >
                          <path
                            d="M16 18.5551L7.05703 27.4981C6.72243 27.8327 6.29658 28 5.77947 28C5.26236 28 4.8365 27.8327 4.5019 27.4981C4.1673 27.1635 4 26.7376 4 26.2205C4 25.7034 4.1673 25.2776 4.5019 24.943L13.4449 16L4.5019 7.05703C4.1673 6.72243 4 6.29658 4 5.77947C4 5.26236 4.1673 4.8365 4.5019 4.5019C4.8365 4.1673 5.26236 4 5.77947 4C6.29658 4 6.72243 4.1673 7.05703 4.5019L16 13.4449L24.943 4.5019C25.2776 4.1673 25.7034 4 26.2205 4C26.7376 4 27.1635 4.1673 27.4981 4.5019C27.8327 4.8365 28 5.26236 28 5.77947C28 6.29658 27.8327 6.72243 27.4981 7.05703L18.5551 16L27.4981 24.943C27.8327 25.2776 28 25.7034 28 26.2205C28 26.7376 27.8327 27.1635 27.4981 27.4981C27.1635 27.8327 26.7376 28 26.2205 28C25.7034 28 25.2776 27.8327 24.943 27.4981L16 18.5551Z"
                            fill="black"
                            fillOpacity="0.6"
                          />
                        </svg>
                      </button>
                    </div>
                    <div className="overview">
                      <h4>Role Overview:</h4>
                      <p>{jobDetails.description}</p>
                    </div>
                    <h4>Key Responsibilities:</h4>
                    <ul>
                      {jobDetails.responsibilities.map((item, index) => (
                        <li key={index}>
                          <div className="svg-box">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="10"
                              height="10"
                              viewBox="0 0 10 10"
                              fill="none"
                            >
                              <circle cx="5" cy="5" r="5" fill="#555" />
                            </svg>
                            <p>{item}</p>
                          </div>
                        </li>
                      ))}
                    </ul>
                    <h4>Requirements:</h4>
                    <ul>
                      {jobDetails.requirements.map((item, index) => (
                        <li key={index}>
                          <div className="svg-box">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="10"
                              height="10"
                              viewBox="0 0 10 10"
                              fill="none"
                            >
                              <circle cx="5" cy="5" r="5" fill="#555" />
                            </svg>
                            <p>{item}</p>
                          </div>
                        </li>
                      ))}
                    </ul>
                    {jobDetails.preferredSkills && (
                      <>
                        <h4>Preferred Skills:</h4>
                        <ul>
                          {jobDetails.preferredSkills.map((item, index) => (
                            <li key={index}>
                              <div className="svg-box">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="10"
                                  height="10"
                                  viewBox="0 0 10 10"
                                  fill="none"
                                >
                                  <circle cx="5" cy="5" r="5" fill="#555" />
                                </svg>
                                <p>{item}</p>
                              </div>
                            </li>
                          ))}
                        </ul>
                      </>
                    )}
                    {jobDetails.whyJoinUs && (
                      <>
                        <h4>Why Join Us?</h4>
                        <ul>
                          {jobDetails.whyJoinUs.map((item, index) => (
                            <li key={index}>
                              <div className="svg-box">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="10"
                                  height="10"
                                  viewBox="0 0 10 10"
                                  fill="none"
                                >
                                  <circle cx="5" cy="5" r="5" fill="#555" />
                                </svg>
                                <p>{item}</p>
                              </div>
                            </li>
                          ))}
                        </ul>
                      </>
                    )}
                    <div className="form-container">
                      <div className="form-intro">
                        <h4>Candidate Profile</h4>
                        <p>Please be sure to fill out all required fields.</p>
                        <p>* indicates a required field.</p>
                      </div>
                      <div className="form-right">
                        <form onSubmit={handleSubmit}>
                          <div className="input-box">
                            <input
                              type="text"
                              name="firstName"
                              placeholder="* First Name"
                              value={formData.firstName}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="input-box">
                            <input
                              type="text"
                              name="lastName"
                              placeholder="* Last Name"
                              value={formData.lastName}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="input-box">
                            <input
                              type="email"
                              name="email"
                              placeholder="* Email Address"
                              value={formData.email}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="input-box">
                            <input
                              type="text"
                              name="phone"
                              placeholder="* Phone Number"
                              value={formData.phone}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="file-upload-box">
                            <p>* Work Experience</p>
                            <div className="input-box upload-area">
                              <label
                                htmlFor="fileInput"
                                className="upload-label mb-0"
                              >
                                <div className="upload-content">
                                  <div className="icon-box">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="41"
                                      height="40"
                                      viewBox="0 0 41 40"
                                      fill="none"
                                    >
                                      <g clipPath="url(#clip0_712_261)">
                                        <path
                                          d="M32.75 16.7337C31.6167 10.9837 26.5667 6.66699 20.5 6.66699C15.6833 6.66699 11.5 9.40033 9.41667 13.4003C4.4 13.9337 0.5 18.1837 0.5 23.3337C0.5 28.8503 4.98333 33.3337 10.5 33.3337H32.1667C36.7667 33.3337 40.5 29.6003 40.5 25.0003C40.5 20.6003 37.0833 17.0337 32.75 16.7337ZM23.8333 21.667V28.3337H17.1667V21.667H12.1667L20.5 13.3337L28.8333 21.667H23.8333Z"
                                          fill="black"
                                          fillOpacity="0.6"
                                        />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_712_261">
                                          <rect
                                            width="40"
                                            height="40"
                                            fill="white"
                                            transform="translate(0.5)"
                                          />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                  </div>
                                  <div className="text">
                                    <p className="mb-2">
                                      Drag & Drop your files here
                                    </p>
                                    <p className="mb-0">
                                      (PDF, DOCX, TXT or HTML)
                                    </p>
                                  </div>
                                </div>
                              </label>
                              <input
                                type="file"
                                id="fileInput"
                                accept=".pdf,.docx,.txt,.html"
                                onChange={handleChange}
                                style={{ display: "none" }}
                              />
                            </div>
                            {uploadMessage && (
                              <p className="upload-message">{uploadMessage}</p>
                            )}
                          </div>
                          <div className="input-box">
                            <label>LinkedIn Profile</label>
                            <input
                              type="text"
                              name="linkedin"
                              placeholder="Profile URL"
                              value={formData.linkedin}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="input-box">
                            <label>Work Samples</label>
                            <input
                              type="text"
                              name="workSamples"
                              placeholder="Personal Website, Portfolio, GitHub etc."
                              value={formData.workSamples}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="input-box textarea">
                            <textarea
                              name="additionalInfo"
                              placeholder="Additional Information..."
                              value={formData.additionalInfo}
                              onChange={handleChange}
                            />
                          </div>
                          <button
                            className="btn"
                            type="submit"
                            disabled={isSending}
                            style={{
                              opacity:
                                formData.file || formData.firstName ? 1 : 0.5,
                              pointerEvents:
                                formData.file || formData.firstName
                                  ? "auto"
                                  : "none",
                            }}
                          >
                            {isSending ? "Sending..." : "Send Message"}
                          </button>
                          {uploadMessage && (
                            <p className="upload-message">{uploadMessage}</p>
                          )}
                        </form>
                      </div>
                    </div>
                  </div>
                ) : (
                  <FirstComponent />
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="work-container">
            <div className="title">
              <h1>
                Company Culture at <span className="title-word">CS Lab</span>
              </h1>
            </div>
            <div className="box box-1">
              <div className="box-left">
                <div className="image-box">
                  <img src={AboutOne} alt="BrainStorm" />
                </div>
              </div>
              <div className="box-right">
                <div className="text-box">
                  <h1>1. Creativity and Innovation</h1>
                  <p>
                    At CS Lab, we believe creativity is the cornerstone of
                    impactful marketing solutions. Our team is constantly
                    encouraged to think outside the box, explore bold ideas, and
                    embrace unconventional approaches to problem-solving. This
                    commitment to creativity ensures that we always deliver
                    innovative solutions tailored to our clients' needs.
                  </p>
                  <p>
                    By fostering a culture of innovation, we create a dynamic
                    and engaging workplace. Every project becomes an opportunity
                    to experiment, learn, and push the boundaries of what’s
                    possible, making each achievement even more rewarding.
                  </p>
                </div>
              </div>
            </div>
            <div className="box box-2">
              <div className="box-right">
                <div className="text-box">
                  <h1>2. Collaboration and Integrity</h1>
                  <p>
                    Collaboration lies at the heart of our success at CS Lab. We
                    maintain a transparent and inclusive environment where team
                    members work together closely, sharing insights, skills, and
                    feedback to achieve common goals. This spirit of teamwork
                    ensures that no challenge is faced alone and that every
                    voice is heard.
                  </p>
                  <p>
                    Integrity is equally vital to our culture, guiding every
                    decision and interaction. We foster trust by promoting open
                    communication, respecting diverse perspectives, and
                    empowering individuals to contribute meaningfully. Together,
                    these values create a supportive and inspiring workplace.
                  </p>
                </div>
              </div>
              <div className="box-left">
                <div className="image-box">
                  <img src={AboutTwo} alt="BrainStorm" />
                </div>
              </div>
            </div>
            <div className="box box-3">
              <div className="box-left">
                <div className="image-box">
                  <img src={AboutThree} alt="BrainStorm" />
                </div>
              </div>
              <div className="box-right">
                <div className="text-box">
                  <h1>3. Growth and Results</h1>
                  <p>
                    Growth is a shared journey at CS Lab. We invest in our team
                    by providing continuous learning opportunities, access to
                    the latest tools, and exposure to industry trends. This
                    commitment ensures that our employees are always equipped to
                    excel in a fast-evolving digital landscape.
                  </p>
                  <p>
                    Our focus on measurable results keeps us driven and
                    motivated. Every project is approached with a
                    results-oriented mindset, enabling our team to achieve
                    meaningful outcomes that fuel both client success and
                    personal fulfillment.
                  </p>
                </div>
              </div>
            </div>
            <div className="job-listing">
              <div className="job-listing-left">
                <div className="title">
                  <h2>
                    <span className="title-word">Job</span> Listing (
                    {careers.length})
                  </h2>
                  <p>Filters</p>
                </div>
                {careers.map((career) => (
                  <div className="career" key={career.id}>
                    <div
                      className="job-card"
                      onClick={() => handleJobClick(career.id)} // Toggle expand/collapse
                    >
                      <div className="job-title">
                        <div className="text">
                          <h3>{career.category}</h3>
                          <p>({career.avalibleJobs} Opening)</p>
                        </div>
                        <div className="icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="48"
                            height="48"
                            viewBox="0 0 48 48"
                            fill="none"
                          >
                            <path
                              d="M13.4108 18.5894C14.1893 17.8109 15.4514 17.8102 16.2308 18.5879L22.5873 24.9306C23.368 25.7096 24.632 25.7096 25.4127 24.9306L31.7692 18.5879C32.5486 17.8102 33.8107 17.8109 34.5892 18.5894C35.3684 19.3686 35.3684 20.6318 34.5892 21.4109L25.4142 30.586C24.6332 31.367 23.3668 31.367 22.5858 30.586L13.4108 21.4109C12.6316 20.6318 12.6316 19.3686 13.4108 18.5894Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                      </div>
                      {expandedJobId === career.id && (
                        <div className="positions">
                          {career.positions.map((position) => (
                            <div
                              className={`position ${
                                selectedPositionId === position.id
                                  ? "active"
                                  : ""
                              }`}
                              key={position.id}
                            >
                              <p>{position.title}</p>
                              <button
                                onClick={(e) => {
                                  e.stopPropagation(); // Prevent card click
                                  handleApplyClick(position.id); // Show position details
                                }}
                              >
                                Apply Now
                              </button>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    {/* Expand to show positions */}
                  </div>
                ))}
              </div>
              <div className="job-listing-right">
                {selectedPosition ? (
                  <div className="second-component">
                    <div className="details-header">
                      <h3>{selectedPosition.title}</h3>
                      <button className="close-button" onClick={handleCloseJob}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                        >
                          <path
                            d="M16 18.5551L7.05703 27.4981C6.72243 27.8327 6.29658 28 5.77947 28C5.26236 28 4.8365 27.8327 4.5019 27.4981C4.1673 27.1635 4 26.7376 4 26.2205C4 25.7034 4.1673 25.2776 4.5019 24.943L13.4449 16L4.5019 7.05703C4.1673 6.72243 4 6.29658 4 5.77947C4 5.26236 4.1673 4.8365 4.5019 4.5019C4.8365 4.1673 5.26236 4 5.77947 4C6.29658 4 6.72243 4.1673 7.05703 4.5019L16 13.4449L24.943 4.5019C25.2776 4.1673 25.7034 4 26.2205 4C26.7376 4 27.1635 4.1673 27.4981 4.5019C27.8327 4.8365 28 5.26236 28 5.77947C28 6.29658 27.8327 6.72243 27.4981 7.05703L18.5551 16L27.4981 24.943C27.8327 25.2776 28 25.7034 28 26.2205C28 26.7376 27.8327 27.1635 27.4981 27.4981C27.1635 27.8327 26.7376 28 26.2205 28C25.7034 28 25.2776 27.8327 24.943 27.4981L16 18.5551Z"
                            fill="black"
                            fillOpacity="0.6"
                          />
                        </svg>
                      </button>
                    </div>
                    <div className="overview">
                      <h4>Role Overview:</h4>
                      <p>{selectedPosition.description}</p>
                    </div>
                    <h4>Key Responsibilities:</h4>
                    <ul>
                      {selectedPosition.responsibilities.map((item, index) => (
                        <li key={index}>
                          <div className="svg-box">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="10"
                              height="10"
                              viewBox="0 0 10 10"
                              fill="none"
                            >
                              <circle cx="5" cy="5" r="5" fill="#555" />
                            </svg>
                            <p>{item}</p>
                          </div>
                        </li>
                      ))}
                    </ul>
                    <h4>Requirements:</h4>
                    <ul>
                      {selectedPosition.requirements.map((item, index) => (
                        <li key={index}>
                          <div className="svg-box">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="10"
                              height="10"
                              viewBox="0 0 10 10"
                              fill="none"
                            >
                              <circle cx="5" cy="5" r="5" fill="#555" />
                            </svg>
                            <p>{item}</p>
                          </div>
                        </li>
                      ))}
                    </ul>
                    {selectedPosition.preferredSkills && (
                      <>
                        <h4>Preferred Skills:</h4>
                        <ul>
                          {selectedPosition.preferredSkills.map(
                            (item, index) => (
                              <li key={index}>
                                <div className="svg-box">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="10"
                                    height="10"
                                    viewBox="0 0 10 10"
                                    fill="none"
                                  >
                                    <circle cx="5" cy="5" r="5" fill="#555" />
                                  </svg>
                                  <p>{item}</p>
                                </div>
                              </li>
                            )
                          )}
                        </ul>
                      </>
                    )}
                    {selectedPosition.whyJoinUs && (
                      <>
                        <h4>Why Join Us?</h4>
                        <ul>
                          {selectedPosition.whyJoinUs.map((item, index) => (
                            <li key={index}>
                              <div className="svg-box">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="10"
                                  height="10"
                                  viewBox="0 0 10 10"
                                  fill="none"
                                >
                                  <circle cx="5" cy="5" r="5" fill="#555" />
                                </svg>
                                <p>{item}</p>
                              </div>
                            </li>
                          ))}
                        </ul>
                      </>
                    )}
                    <div className="form-container">
                      <div className="form-intro">
                        <h4>Candidate Profile</h4>
                        <p>Please be sure to fill out all required fields.</p>
                        <p>* indicates a required field.</p>
                      </div>
                      <div className="form-right">
                        <form onSubmit={handleSubmit}>
                          <div className="input-box">
                            <input
                              type="text"
                              name="firstName"
                              placeholder="* First Name"
                              value={formData.firstName}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="input-box">
                            <input
                              type="text"
                              name="lastName"
                              placeholder="* Last Name"
                              value={formData.lastName}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="input-box">
                            <input
                              type="email"
                              name="email"
                              placeholder="* Email Address"
                              value={formData.email}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="input-box">
                            <input
                              type="text"
                              name="phone"
                              placeholder="* Phone Number"
                              value={formData.phone}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="file-upload-box">
                            <p>* Work Experience</p>
                            <div className="input-box upload-area">
                              <label
                                htmlFor="fileInput"
                                className="upload-label mb-0"
                              >
                                <div className="upload-content">
                                  <div className="icon-box">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="41"
                                      height="40"
                                      viewBox="0 0 41 40"
                                      fill="none"
                                    >
                                      <g clipPath="url(#clip0_712_261)">
                                        <path
                                          d="M32.75 16.7337C31.6167 10.9837 26.5667 6.66699 20.5 6.66699C15.6833 6.66699 11.5 9.40033 9.41667 13.4003C4.4 13.9337 0.5 18.1837 0.5 23.3337C0.5 28.8503 4.98333 33.3337 10.5 33.3337H32.1667C36.7667 33.3337 40.5 29.6003 40.5 25.0003C40.5 20.6003 37.0833 17.0337 32.75 16.7337ZM23.8333 21.667V28.3337H17.1667V21.667H12.1667L20.5 13.3337L28.8333 21.667H23.8333Z"
                                          fill="black"
                                          fillOpacity="0.6"
                                        />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_712_261">
                                          <rect
                                            width="40"
                                            height="40"
                                            fill="white"
                                            transform="translate(0.5)"
                                          />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                  </div>
                                  <div className="text">
                                    <p className="mb-2">
                                      Drag & Drop your files here
                                    </p>
                                    <p className="mb-0">
                                      (PDF, DOCX, TXT or HTML)
                                    </p>
                                  </div>
                                </div>
                              </label>
                              <input
                                type="file"
                                id="fileInput"
                                accept=".pdf,.docx,.txt,.html"
                                onChange={handleChange}
                                style={{ display: "none" }}
                              />
                            </div>
                            {uploadMessage && (
                              <p className="upload-message">{uploadMessage}</p>
                            )}
                          </div>
                          <div className="input-box">
                            <label>LinkedIn Profile</label>
                            <input
                              type="text"
                              name="linkedin"
                              placeholder="Profile URL"
                              value={formData.linkedin}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="input-box">
                            <label>Work Samples</label>
                            <input
                              type="text"
                              name="workSamples"
                              placeholder="Personal Website, Portfolio, GitHub etc."
                              value={formData.workSamples}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="input-box textarea">
                            <textarea
                              name="additionalInfo"
                              placeholder="Additional Information..."
                              value={formData.additionalInfo}
                              onChange={handleChange}
                            />
                          </div>
                          <button
                            className="btn"
                            type="submit"
                            disabled={isSending}
                            style={{
                              opacity:
                                formData.file || formData.firstName ? 1 : 0.5,
                              pointerEvents:
                                formData.file || formData.firstName
                                  ? "auto"
                                  : "none",
                            }}
                          >
                            {isSending ? "Sending..." : "Send Message"}
                          </button>
                          {uploadMessage && (
                            <p className="upload-message">{uploadMessage}</p>
                          )}
                        </form>
                      </div>
                    </div>
                  </div>
                ) : (
                  <FirstComponent />
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </section>
  );
};

export default WorkWithUs;
